import React, {useState, useEffect} from "react";
import { Trans } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import { organisationIdState, collapsedSidebarState } from "../../atoms";
import { useSetRecoilState, useRecoilState } from "recoil";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap';
import { NotificationManager } from "react-notifications";
import TipSequence from 'components/Tips/TipSequence';

let tips = [
    {
        id: 'organisation-selector',
        text: 'Select an organisation from the dropdown.',
        targetId: 'organisation-selector',
        position: 'bottom',
        delay: 500,
    },
    {
        id: 'manage-organisation',
        text: 'Go to your organisation list by clicking on the button.',
        targetId: 'manage-organisation',
        position: 'left',
        delay: 500,
        targetUrl: '/organisations',
    },
];

const SelectOrganisation = (props) => {

    const [ showMenu, setShowMenu ] = React.useState(false);

    const [ currentActive, setCurrentActive ] = React.useState(false);
    
    const setOrganisationId = useSetRecoilState(organisationIdState);

    const [collapsedSidebar, setCollapsedSidebar] = useRecoilState(collapsedSidebarState);

    const history = useHistory()

    useEffect(() => {
        let tip = tips.find(tip => tip.id === 'organisation-selector')

        if (tip) {
            tip.onComplete = () => {
                toggleDropdown()
            }
        }
    }, [])

    useEffect(() => {
        
        if(showMenu ===true){
            setCurrentActive(true)
        }else{
            setCurrentActive(false)
        }
    }, [showMenu])

    useEffect(() => {

        if((props.selectedOrganisation=== (null || 0 || undefined )) && (props?.organisations?.length > 0)){
            setOrganisationId(props?.organisations?.[0]?.id);
        }
    }, [props.selectedOrganisation, props.organisations])

    useEffect(() => {
        if(collapsedSidebar===true){
            setShowMenu(false)
        }
    }, [collapsedSidebar])

    const toggleDropdown = () => setShowMenu(prevState => !prevState);

    const handleOrganisationClick = (organisationId) => {
        if (organisationId === props?.selectedOrganisation?.id) {
            NotificationManager.info("The Organisation is already selected")
            return
        } 
        setOrganisationId(organisationId);
        setShowMenu(false);

        setTimeout(() => {
            window.location.reload()
        }, 1000)
    };

    
    const goToManage = (ifNew=false) => {
        history.push({
            pathname: `/organisations${ifNew ? "/new" : ""}`,
          })
    }

    const limitToThreeWords = (str) => {
        const words = str.split(' ');
        if (words.length > 3 || (words.length === 3 && str.length > 23)) {
            return words.slice(0, 3).join(' ').substring(0, 23) + '...';
        }
        return str;
    };
    return (
        <>
            <Dropdown isOpen={showMenu} toggle={toggleDropdown} id="organisation-selector">

              <DropdownToggle outline size="sm" className="text-truncate" color={(currentActive ? (props.selectedOrganisation?.status !== "LIVE" ? "danger" : "success") : "secondary")} caret style={{ width:200 }}
              >{props.selectedOrganisation ? props.selectedOrganisation.name : (<Trans>No Organisations Selected</Trans>)}<span className={`fa fa-chevron-${showMenu ? "up" : "down"} fa-fw ml-1`} /></DropdownToggle>

                <DropdownMenu style={{width:200}}>
                    <div className="mt-2"/>
                    {props.organisations &&
                        props.organisations.map((i) => (
                            <DropdownItem
                                key={i.id}
                                onClick={() => handleOrganisationClick(i.id)}
                                tag={Link}
                                disabled={i.id === props?.selectedOrganisation?.id}
                                className={(i.status !== "LIVE" ? "text-danger" : "") + " mt-1 text-truncate"}
                            >
                                {i.name} 
                                <span style={{}}></span>
                                {/* {i.status==="LIVE" ? (<span className="fa fa-check-circle text-success" />) : (<span className="fa fa-times-circle text-danger" />)} */}
                            </DropdownItem>
                        ))}
                    {props.userGroup === "Superadmin" &&
                        <div className="d-flex justify-content-center mt-2">
                            <Button size="sm" color="primary" className="w-100" onClick={()=> goToManage()} id="manage-organisation"><Trans>Manage All</Trans></Button>
                            <Button size="sm" color="primary" className="ml-0" onClick={()=> goToManage(true)}>+</Button>
                            {/* <Button size="sm" color="primary" className="ml-0" onClick={() => handleOrganisationClick(null)}>-</Button> */}
                        </div>
                    }
                    
                </DropdownMenu>
            </Dropdown>

            <TipSequence tips={tips} />
        </>
    );
}
export default SelectOrganisation;

